// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vconsole from 'vconsole'
import Components from './components'
import rem from '../rem'
import MintUi from 'mint-ui'
import 'mint-ui/lib/style.css'

// const vConsole = new Vconsole()

// Vue.use(vConsole)
Vue.use(MintUi)
Vue.use(Components);
Vue.use(rem)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js